// columnsDataOrders.js
export const columnsDataOrders = [
  {
    Header: 'PRODUCT NAME',
    accessor: 'name',
  },
  {
    Header: 'EMAIL',
    accessor: 'email',
  },
  {
    Header: 'PHONE',
    accessor: 'phone',
  },
  {
    Header: 'PAYMENT METHOD',
    accessor: 'paymentMethod',
  },
  {
    Header: 'DATE & TIME',
    accessor: 'dateTime',
  },
  {
    Header: 'STATUS ORDER',
    accessor: 'status',
  },
  {
    Header: 'TOTAL PRICE',
    accessor: 'price',
  },
  {
    Header: 'ORDER ACTIONS',
    accessor: 'actions',
  },
];
